"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainnetRaydiumFarms = exports.getMainnetRaydiumPools = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const web3_js_1 = require("@solana/web3.js");
const raydium_sdk_1 = require("@raydium-io/raydium-sdk");
const SOL_PK = new web3_js_1.PublicKey("11111111111111111111111111111111");
const getMainnetRaydiumPools = (filter) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const poolsRet = yield (0, cross_fetch_1.default)("https://sdk.raydium.io/liquidity/mainnet.json", { cache: "reload" });
    const pools = (yield poolsRet.json()).official.map(raydium_sdk_1.jsonInfo2PoolKeys);
    let poolsFiltered = pools;
    if (filter === null || filter === void 0 ? void 0 : filter.version) {
        poolsFiltered = poolsFiltered.filter((p) => p.version === filter.version);
    }
    if (filter === null || filter === void 0 ? void 0 : filter.matchesMints) {
        poolsFiltered = poolsFiltered.filter((p) => (p.baseMint.equals(filter.matchesMints[0]) &&
            p.quoteMint.equals(filter.matchesMints[1])) ||
            (p.baseMint.equals(filter.matchesMints[1]) &&
                p.quoteMint.equals(filter.matchesMints[0])));
    }
    if (filter === null || filter === void 0 ? void 0 : filter.hasFarm) {
        const farmPools = yield (0, exports.getMainnetRaydiumFarms)();
        let farmsToCheck = farmPools;
        farmsToCheck = ((_a = filter.hasFarm) === null || _a === void 0 ? void 0 : _a.version)
            ? farmPools.filter((f) => f.version === filter.hasFarm.version)
            : farmPools;
        poolsFiltered = poolsFiltered.filter((lpPool) => farmsToCheck.find((farm) => {
            const r = farm.lpMint.equals(lpPool.lpMint);
            return r;
        }));
    }
    return poolsFiltered;
});
exports.getMainnetRaydiumPools = getMainnetRaydiumPools;
const getMainnetRaydiumFarms = (filter) => __awaiter(void 0, void 0, void 0, function* () {
    const poolsRet = yield (0, cross_fetch_1.default)("https://sdk.raydium.io/farm/mainnet.json");
    const pools = (yield poolsRet.json()).official.map(raydium_sdk_1.jsonInfo2PoolKeys);
    let poolsFiltered = pools;
    if (filter === null || filter === void 0 ? void 0 : filter.lpMint) {
        poolsFiltered = poolsFiltered.filter((p) => p.lpMint.equals(filter.lpMint));
    }
    return poolsFiltered;
});
exports.getMainnetRaydiumFarms = getMainnetRaydiumFarms;
